import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Vendor } from '../../model/vendor';

export type VendorListState = {
  data: Vendor[];
  loading: boolean;
  error: string | null;
  toggleValue: number;
};

const initialState: VendorListState = {
  data: [],
  loading: false,
  error: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'vendorList',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<Vendor[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
  },
});

export const vendorList = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed } = slice.actions;
